export function convertBase64ToFile({ file, fileName, fileExtension }) {
  const sanitizedFileName = fileName.replace(/^"|"$/g, '').trim();
  const blob = new Blob([file.data], { type: 'application/' + fileExtension });
  const download = document.createElement('a');

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, sanitizedFileName);
  } else {
    download.href = window.URL.createObjectURL(blob);
    download.download = sanitizedFileName;
  }
  download.style.visibility = 'hidden';
  document.body.appendChild(download);
  download.click();

  return download;
}

export function justDownloadBase64File (contentType, base64Data, fileName) {
  const linkSource = `data:${contentType};base64,${base64Data}`
  const downloadLink = document.createElement('a')
  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}
